module.exports = __webpack_public_path__ + "static/media/footer_mobile@2x.a8c1caee.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/planning/footer_mobile@2x.jpg
 ** module id = 2291
 ** module chunks = 50
 **/